import {CustomCellRendererProps} from '@ag-grid-community/react';
import {IconCircleCheckFilled} from "@tabler/icons-react";

export type ValidationCellProps = CustomCellRendererProps<boolean> & {}

export const ValidationCell = (props: ValidationCellProps) => {
  const {value} = props
  return value ? <IconCircleCheckFilled size={14}/> : undefined;
}
